import React from 'react';
import styled from 'styled-components';
const ShowRoom = () => {
    return ( 
        <section>
            <ShowRoomH2>Visita nuestra fabrica</ShowRoomH2>
            <ShowRoomContainer>
                <br></br>
                <p><a href='https://maps.app.goo.gl/oNk4zUCMhqMVJt4V7'>Granaditas 216, Barrio de la Estación,
                    <br/> 20259 Aguascalientes, Ags.
                </a></p>
                <p>Horario:</p>
                <p>Lunes a Viernes 
                    <br/>de:</p>
                <h2>9am - 5pm</h2>
                <ShowRoomMap src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6226.65298865841!2d-102.27934759648184!3d21.881052117205666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8429ee72dc6f8f75%3A0x297812d1b428c8e!2sGranaditas%20216%2C%20Barrio%20de%20la%20Estaci%C3%B3n%2C%2020259%20Aguascalientes%2C%20Ags.!5e0!3m2!1ses-419!2smx!4v1745442308712!5m2!1ses-419!2smx" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></ShowRoomMap>
            </ShowRoomContainer>
        </section>
     );
}

const ShowRoomH2 = styled.h2 `
    margin-bottom: 10px;
    text-align: center;
`

const ShowRoomContainer = styled.div `
background-color:  #010755;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 5;
max-width: 900px;
margin: auto;
box-shadow: 0px 1px 15px #1118;
color: #fff;
    p, a{
        text-align: center;
        font-size: large;
        margin: 5px;
        color: #fff;
    }
`
const ShowRoomMap = styled.iframe `
    width: 100%;
    height: 350px;
    border: none;
`
export default ShowRoom;